import { styled } from "styled-components";

import { colorCSS, fontSizes } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

const Link = styled.a`
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("gap", "0.25rem")}
    ${redundantCssFromKebab("text-decoration", "none")}
    ${redundantCssFromKebab("transition", "0.2s gap ease")}

    &:hover {
        ${redundantCssFromKebab("gap", "0.5rem")}
        ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    }
`;

export default Link;
